export default __webpack_public_path__ + "fdc80c3c44fe6d3e87213bf5117812f6.png";